import cn from "classnames";
import { useTranslation } from "react-i18next";

import styles from "./ExpeditionBadge.module.scss";

interface ExpeditionBadgeProps {
  className?: string;
}

export const ExpeditionBadge = ({ className }: ExpeditionBadgeProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(styles.expeditionBadge, className)}
      title={t("Expedition order — delivered to a city outside Abidjan")}
    >
      {t("EXPEDITION")}
    </div>
  );
};

export default ExpeditionBadge;
